import React from 'react';
import { ClipboardList, FileText, TrendingUp } from 'lucide-react';
import { howItWorks } from '../data/mock';
import { howItWorksVisual } from '../data/audienceContent';
import { useAudience } from '../contexts/AudienceContext';
import { BrandName } from './BrandName';

const iconComponents = {
  ClipboardList,
  FileText,
  TrendingUp
};

const HowItWorksSection = () => {
  const { audience } = useAudience();
  const banner = howItWorksVisual[audience];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-10">
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-gray-900 mb-6 tracking-tight">
            The <BrandName /> Process
          </h2>
          <p className="text-xl text-gray-600">
            Simple on the outside. Smart underneath.
          </p>
        </div>

        <div className="max-w-5xl mx-auto mb-14 rounded-3xl overflow-hidden shadow-xl border border-gray-100">
          <img
            src={banner.src}
            alt={banner.alt}
            width={1400}
            height={560}
            loading="lazy"
            decoding="async"
            className="w-full h-auto object-cover max-h-[240px] sm:max-h-[280px] md:max-h-[340px]"
          />
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {howItWorks.map((item, index) => {
            const IconComponent = iconComponents[item.icon];
            return (
              <div 
                key={item.id}
                className="relative group"
              >
                {/* Connector line */}
                {index < howItWorks.length - 1 && (
                  <div className="hidden md:block absolute top-16 left-full w-full h-0.5 bg-gradient-to-r from-blue-300 to-teal-300 -translate-x-1/2 z-0"></div>
                )}
                
                <div className="relative bg-white p-8 rounded-2xl border-2 border-gray-200 hover:border-blue-400 transition-all duration-300 hover:shadow-xl z-10">
                  {/* Step number badge */}
                  <div className="absolute -top-4 -right-4 w-12 h-12 bg-gradient-to-br from-blue-600 to-teal-600 rounded-full flex items-center justify-center shadow-lg">
                    <span className="text-white font-bold text-lg">{index + 1}</span>
                  </div>

                  <div className="w-16 h-16 bg-gradient-to-br from-blue-100 to-teal-100 rounded-2xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="w-8 h-8 text-blue-700" />
                  </div>

                  <div className="text-sm font-semibold text-teal-600 mb-2">{item.step}</div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">
                    {item.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
